module.exports = __webpack_public_path__ + "blackom.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blackom.png
// module id = 864
// module chunks = 0